<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex">
			<h1>Purchase order {{ record.id }}</h1>
      <div class="flex-grow text-right">
<!--        <button v-on:click="syncWithWarehouse()" class="small-margin-right">Update from warehouse</button>-->
        <button v-if="!record.closed_at" v-on:click="closed()" class="small-margin-right">Mark as closed in warehouse</button>
        <button v-on:click="refresh()" class="small-margin-right small-margin-top">Update from Uniconta</button>
        <button v-on:click="synchronizeLines()" class="small-margin-right">Synchronize (50) lines</button>
      </div>
		</div>

		<div class="margin-top">
			<div class="input-row small-margin-bottom">
				<span class="label">Created</span>
				<div>{{ record.created_at }}</div>
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Reference 1</span>
				<div>{{ record.reference_1 }}</div>
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Reference 2</span>
				<div>{{ record.reference_2 }}</div>
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Delivery date</span>
				<div>{{ record.delivery_date }}</div>
			</div>
      <div class="input-row small-margin-bottom">
				<span class="label">Last updated from warehouse</span>
				<div>
          <div>{{ record.last_synced_at }}</div>
        </div>
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Closed at</span>
				<div v-if="record.closed_at">{{ record.closed_at }}</div>
				<div v-if="!record.closed_at">
          <div>PO is still active to take update from warehouse</div>
        </div>
			</div>

			<Loader v-if="soft_loading" :soft="true" />

			<h2 class="margin-top">Lines</h2>
			<Table :columns="columns" :rows="lines" />
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    soft_loading: false,
    record: {
      lines: []
    },
    columns: {
      text: {},
      ean: {},
      qty: {},
      qty_received: {},
      size: {},
      color: {},
      uniconta_sync_at: {},
      wp_sync_at: {}
    }
  }),
  computed: {
    lines () {
      return this.record.lines.map(row => {
        row.menu = [
          {
            name: 'Synchronize',
            onClick: row => this.synchronize(row)
          }
        ]

        return row
      })
    }
  },
  methods: {
    finished () {
      Vue.$api.post('/purchase-order/' + this.getId() + '/complete', {}, {
        loader: toggle => this.soft_loading = toggle,
        callback: () => this.load()
      })
    },
    closed () {
      Vue.$api.post('/purchase-order/' + this.getId() + '/close', {}, {
        loader: toggle => this.soft_loading = toggle,
        callback: () => this.load()
      })
    },
    syncWithWarehouse () {
      Vue.$api.post('/purchase-order/' + this.getId() + '/synchronize-with-warehouse', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.load()
      })
    },
    repairQtyReceived () {
      Vue.$api.post('/purchase-order/' + this.getId() + '/repair-qty-received', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.load()
      })
    },
    synchronizeLines () {
      Vue.$api.post('/purchase-order/' + this.getId() + '/synchronize-lines', { limit: 50 }, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.load()
      })
    },
    synchronize (row) {
      Vue.$api.post('/purchase-order/' + this.getId() + '/line/' + row.id + '/synchronize', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.load()
      })
    },
    refresh () {
      Vue.$api.post('/purchase-order/' + this.getId() + '/refresh', {}, {
        before: () => this.soft_loading = true,
        always: () => this.soft_loading = false,
        callback: () => this.load()
      })
    },
    getId () {
      return this.$route.params.id
    },
    load () {
      Vue.$api.get('/purchase-order/' + this.getId(), {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.record = data
    }
  },
  created () {
    this.load()
  }
}
</script>
